export default {
    ALIVE : 'ALIVE',
    DEAD : 'DEAD'
}